// Mirror of backend advanced_engine.match_sort_key: overall match, Academic score, grade gap
// (high → low), then university and course name A → Z, then course id.
const num = (v, d) => (typeof v === "number" && !Number.isNaN(v) ? v : d);
const txt = (v) => (v || "").toLocaleLowerCase();
const cmpText = (a, b) => (a < b ? -1 : a > b ? 1 : 0);

export function compareMatch(a, b) {
  return (num(b.overall_match, 0) - num(a.overall_match, 0))
    || (num(b.academic?.score, 0) - num(a.academic?.score, 0))
    || (num(b.academic?.gap_score, -9) - num(a.academic?.gap_score, -9))
    || cmpText(txt(a.university_name), txt(b.university_name))
    || cmpText(txt(a.degree_name), txt(b.degree_name))
    || cmpText(a.degree_id || "", b.degree_id || "");
}

// Within one university, a shortlisted course leads when it exactly ties the top overall match.
export function promoteShortlisted(groups, savedIds) {
  return groups.map((g) => {
    if (!g.university_id || !g.variations.length || savedIds.has(g.flagship.degree_id)) return g;
    const top = g.flagship.overall_match;
    const pick = g.variations.find((v) => v.overall_match === top && savedIds.has(v.degree_id));
    if (!pick) return g;
    return { ...g, flagship: pick, variations: [g.flagship, ...g.variations.filter((v) => v !== pick)] };
  });
}
